import { render, staticRenderFns } from "./SearchBarIframe.vue?vue&type=template&id=05439b12&"
import script from "./SearchBarIframe.vue?vue&type=script&lang=js&"
export * from "./SearchBarIframe.vue?vue&type=script&lang=js&"
import style0 from "./SearchBarIframe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports